// ============================================================
// DADOS DO SITE - PIBG (Primeira Igreja Brasileira de Greenville)
// ============================================================
// COMO PERSONALIZAR:
// 1. Substitua URLs de imagens por links diretos das suas fotos
// 2. Edite nomes e textos diretamente entre aspas ""
// 3. Para ADICIONAR um item, copie um bloco { ... } e cole após a vírgula
// 4. Para REMOVER, delete o bloco { ... } correspondente
// ============================================================

// ------- INFORMAÇÕES DA IGREJA -------
export const CHURCH = {
  name: "Primeira Igreja Brasileira de Greenville",
  shortName: "PIBG",
  founded: "2019",
  address: "406 E Butler Road, Suite B, Mauldin, SC 29662",
  phone: "(864) 326-7378",
  phoneRaw: "+18643267378",
  email: "pibrasilg@gmail.com",
  socials: {
    instagram: {
      handle: "@pibgreenville",
      url: "https://www.instagram.com/pibgreenville",
    },
    youtube: {
      handle: "@Pibgreenville",
      url: "https://www.youtube.com/@Pibgreenville",
      live: "https://www.youtube.com/@Pibgreenville/live",
    },
    facebook: {
      handle: "/primeiraigrejabrasileiradegreenville",
      url: "https://facebook.com/primeiraigrejabrasileiradegreenville",
    },
  },
};

// ------- IMAGENS PRINCIPAIS -------
export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1503856676083-84edf00f4206?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400";

export const ABOUT_IMAGE = "/about/about-church.jpg";

export const SCHEDULE_IMAGE = "/schedule/schedule-culto.jpg";

// ------- NAVEGAÇÃO DO MENU -------
export const NAV = [
  { label: "Início", href: "#inicio" },
  { label: "Sobre", href: "#sobre" },
  { label: "Cultos", href: "#cultos" },
  { label: "Ministérios", href: "#ministerios" },
  { label: "Eventos", href: "/eventos" },
  { label: "Liderança", href: "/lideranca" },
  { label: "Contato", href: "#contato" },
];

// ------- PROGRAMAÇÃO DE CULTOS -------
export const SCHEDULE = [
  {
    day: "Domingo",
    time: "18h30",
    title: "Culto da Família",
    description:
      "Nosso encontro central da semana — adoração, palavra e comunhão para toda a família.",
  },
  {
    day: "Quinta-feira",
    time: "19h00 · 20h00",
    title: "Discipulado e Oração",
    description:
      "Discipulado às 19h e Culto de Oração às 20h — uma noite inteira buscando a presença de Deus.",
  },
  {
    day: "Sábado",
    time: "18h00",
    title: "Culto dos Jovens",
    description:
      "Geração levantada para Cristo — louvor, mensagem e propósito para jovens.",
  },
];

// ------- MINISTÉRIOS (cards na home + páginas dedicadas) -------
// O campo "slug" gera a URL /ministerios/{slug}
export const MINISTRIES = [
  {
    slug: "louvor",
    title: "Louvor",
    icon: "Music2",
    description:
      "Adoração ao Senhor com excelência, conduzindo a igreja à presença de Deus.",
    hero:
      "/ministries/louvor/PXL_20260215_230732122.MP.jpg",
    tagline:
      "Onde cada acorde é um altar e cada voz, um sacrifício de adoração.",
    history: [
      "O Ministério de Louvor da PIBG nasceu junto com a igreja, em 2019, com a missão de criar um ambiente onde a presença de Deus pudesse ser vivida intensamente a cada culto. O que começou como um pequeno grupo de irmãos com instrumentos simples cresceu para uma equipe diversa, dedicada e comprometida com a excelência ministerial.",
      "Nossa equipe é formada por músicos, vocais e técnicos que ensaiam semanalmente — não apenas para tocar bem, mas para servir bem. Acreditamos que o louvor não é performance: é entrega. Por isso, oramos antes de cada culto, buscamos a Palavra e cuidamos uns dos outros como família.",
    ],
    activities: [
      "Ensaios semanais às quintas-feiras",
      "Ministrações nos cultos de Domingo, Quinta e Sábado",
      "Workshops de música, vocal e adoração",
      "Encontros de oração e comunhão da equipe",
    ],
    gallery: [
      {
        url: "/ministries/louvor/DSC04497~2.JPG",
        alt: "Equipe de louvor durante culto da PIBG",
        caption: "Excelência e entrega — cada ensaio, cada culto, para a glória de Deus",
      },
      {
        url: "/ministries/louvor/PXL_20260208_001325828.MP.jpg",
        alt: "Vocais e instrumentistas ministrando no culto da PIBG",
        caption: "Unidos em um só propósito — conduzir a igreja à presença de Deus",
      },
      {
        url: "/ministries/louvor/PXL_20260215_230814255.TS-000.MP.jpg",
        alt: "Equipe de louvor em plena ministração",
        caption: "Cada nota, um ato de adoração ao Senhor",
      },
      {
        url: "/ministries/louvor/PXL_20260215_231807042.MP.jpg",
        alt: "Músicos e vocais da PIBG louvando juntos",
        caption: "O louvor que transforma — famílias adorando como um só corpo",
      },
    ],
    leaders: [
      {
        name: "Fernando Tomaz",
        role: "Líder do Ministério de Louvor",
        bio:
          "Uma família de adoradores comprometidos em conduzir a igreja à presença do Senhor.",
        image:
          "/ministries-leaders/louvor/louvor-lider-1.jpg",
      },
    ],
    cta: "Quer servir no Louvor? Fale com a liderança após o culto ou envie uma mensagem.",
  },
  {
    slug: "infantil",
    title: "Infantil",
    icon: "Baby",
    description:
      "Plantando a Palavra no coração das crianças com carinho, ensino e diversão.",
    hero: "/ministries/infantil/criancas-culto-1.jpg",
    tagline: "Toda criança merece conhecer Jesus de um jeito que toque o coração.",
    history: [
      "O Ministério Infantil da PIBG existe para que cada criança da nossa comunidade encontre em Jesus o melhor amigo desde os primeiros anos de vida. Acreditamos no que diz Provérbios 22:6: 'Ensina a criança no caminho em que deve andar, e ainda quando for velho não se desviará dele.'",
      "Nossa equipe prepara aulas semanais com louvor infantil, histórias bíblicas, atividades manuais e dinâmicas — sempre com muito amor e atenção individual. Pais podem participar dos cultos com tranquilidade, sabendo que seus filhos estão em um ambiente seguro, acolhedor e centrado em Cristo.",
    ],
    activities: [
      "Culto Infantil aos domingos durante o Culto da Família",
      "Aulas com material bíblico apropriado para cada faixa etária",
      "Eventos especiais: Dia das Crianças, Páscoa Kids, Natal",
      "Cadastro e check-in com segurança para os pais",
    ],
    leaders: [
      {
        name: "Vanessa e Bruna",
        role: "Líderes do Ministério Infantil",
        bio:
          "Servas dedicadas que entregam tempo e coração para investir nas próximas gerações da PIBG.",
        image: null,
      },
    ],
    gallery: [
      {
        url: "/ministries/infantil/PXL_20260216_002019258.TS-000.MP.jpg",
        alt: "Pastor com crianças durante o culto da PIBG",
        caption: "Momento especial do Ministério Infantil com nossas crianças",
      },
      {
        url: "/ministries/infantil/criancas-culto-1.jpg",
        alt: "Crianças participando do culto infantil da PIBG",
        caption: "Cada criança, um tesouro nas mãos de Deus",
      },
      {
        url: "/ministries/infantil/481360188_657974189940778_4437897802677408317_n.jpeg",
        alt: "Crianças da PIBG em momento de louvor e adoração",
        caption: "Louvando a Deus desde pequeninos",
      },
      {
        url: "/ministries/infantil/481448030_657974123274118_304664978319160020_n.jpeg",
        alt: "Crianças participando de atividade bíblica no ministério infantil",
        caption: "Aprendendo a Palavra com alegria",
      },
      {
        url: "/ministries/infantil/481467984_657974269940770_7675362371141357098_n.jpeg",
        alt: "Crianças em momento especial no culto infantil",
        caption: "Cada domingo, um novo encontro com Jesus",
      },
      {
        url: "/ministries/infantil/481482888_657974416607422_2690193988772302975_n.jpeg",
        alt: "Crianças e voluntários no ministério infantil da PIBG",
        caption: "Servindo com amor as próximas gerações",
      },
      {
        url: "/ministries/infantil/481905895_657974246607439_7931954002939508945_n.jpeg",
        alt: "Momento de oração com as crianças do ministério infantil",
        caption: "Ensinando a orar desde cedo",
      },
      {
        url: "/ministries/infantil/482319457_657974259940771_6563462626541266960_n.jpeg",
        alt: "Crianças felizes no culto infantil da PIBG",
        caption: "Alegria que transborda — a infância em Cristo",
      },
      {
        url: "/ministries/infantil/PXL_20260208_003353582~2.jpg",
        alt: "Crianças e equipe do ministério infantil reunidas",
        caption: "Uma família que cresce junta na fé",
      },
    ],
    cta: "Quer voluntariar-se no Infantil? Procure a liderança ou envie um pedido de informações.",
  },
  {
    slug: "jovens",
    title: "Jovens",
    icon: "Flame",
    description:
      "Levantando uma geração apaixonada por Jesus, ousada e cheia do Espírito.",
    hero: null,
    tagline: "Geração que não se envergonha do Evangelho.",
    history: [
      "O Ministério de Jovens da PIBG é mais que um grupo: é uma família. Nasceu da paixão de ver brasileiros adolescentes e jovens nos EUA enraizados em Cristo, mesmo em meio a uma cultura que desafia a fé todos os dias.",
      "Aos sábados nos reunimos para um culto pensado especialmente para os jovens — louvor com energia, mensagens diretas, momentos de oração profundos e tempo de pão e suco com os irmãos. Ao longo do ano realizamos retiros, conferências e ações sociais que marcam a vida de cada um.",
    ],
    activities: [
      "Culto de Jovens — Sábados às 18h",
      "Pequenos grupos de discipulado durante a semana",
      "Retiros e acampamentos anuais",
      "Ações missionárias e sociais",
    ],
    leaders: [
      {
        name: "Matheus e Renan",
        role: "Líderes do Ministério Jovem",
        bio:
          "Discípulos comprometidos em pastorear a próxima geração com verdade, ousadia e amor.",
        image: null,
      },
    ],
    cta: "É jovem? Te esperamos no próximo sábado às 18h. Bora viver Cristo juntos!",
  },
  {
    slug: "danca",
    title: "Dança",
    icon: "Sparkles",
    description:
      "Adoração através do movimento — cada coreografia é um culto ao Senhor.",
    hero:
      "/ministries/danca/danca-hero.jpg",
    tagline: "Davi dançou diante do Senhor com toda a sua força. Nós também.",
    history: [
      "O Ministério de Dança da PIBG entende que adorar é entregar tudo que somos — corpo, alma e espírito. Inspirados em Salmos 149 e na história do rei Davi, nossas dançarinas e dançarinos transformam cada coreografia em uma oração visível.",
      "O ministério participa de cultos especiais, datas comemorativas e eventos congregacionais. Cada apresentação é fruto de horas de ensaio, oração e estudo da letra para que o movimento exalte o conteúdo da canção.",
    ],
    activities: [
      "Ensaios semanais",
      "Ministrações em cultos especiais e datas comemorativas",
      "Workshops com coreógrafos convidados",
      "Tempo de oração e devocional antes de cada apresentação",
    ],
    gallery: [
      {
        url: "/ministries/danca/danca-gallery-1.jpg",
        alt: "Dançarinas da PIBG com figurinos vermelho e preto no evento Sisterhood",
        caption: "Figurinos preparados com dedicação — cada detalhe para a glória de Deus",
      },
      {
        url: "/ministries/danca/danca-gallery-2.jpg",
        alt: "Dançarinas em movimento expressivo durante apresentação",
        caption: "Cada movimento, uma oração ao Senhor",
      },
      {
        url: "/ministries/danca/danca-gallery-3.jpg",
        alt: "Dançarina ministrando com braço erguido em adoração",
        caption: "Davi dançou diante do Senhor com toda a sua força — nós também",
      },
      {
        url: "/ministries/danca/danca-gallery-4.jpg",
        alt: "Dançarinas com bandeiras de adoração durante ministração",
        caption: "Bandeiras erguidas — adoração que toca o coração de Deus",
      },
      {
        url: "/ministries/danca/PXL_20260208_004859422.PORTRAIT.ORIGINAL.jpg",
        alt: "Dançarina em pose expressiva durante ministração",
        caption: "Cada expressão, uma entrega ao Senhor",
      },
      {
        url: "/ministries/danca/PXL_20260208_004902629.PORTRAIT.jpg",
        alt: "Dançarina ministrando com elegância e devoção",
        caption: "O corpo a serviço da adoração",
      },
      {
        url: "/ministries/danca/PXL_20260208_004908771.PORTRAIT.ORIGINAL.jpg",
        alt: "Momento de adoração através da dança na PIBG",
        caption: "Arte e fé — quando o movimento glorifica a Deus",
      },
    ],
    leaders: [
      {
        name: "Izabela e Viviane",
        role: "Líderes do Ministério de Dança",
        bio:
          "Ministrando adoração através da arte e movimento, levando a igreja a experiências profundas com Deus.",
        image: null,
      },
    ],
    cta: "Tem chamado para a dança? Venha conhecer o ministério e fazer parte.",
  },
  {
    slug: "oracao",
    title: "Oração",
    icon: "HandHeart",
    description:
      "Intercedendo pela igreja, pelas famílias e pela comunidade brasileira nos EUA.",
    hero:
      "/ministries/oracao/oracao-hero.jpg",
    tagline: "Onde dois ou três se reúnem, ali Ele está.",
    history: [
      "O Ministério de Oração é o coração espiritual da PIBG. Toda decisão, todo evento, toda mudança nasce primeiro no altar. Acreditamos que sem oração não há ministério genuíno — e por isso mantemos uma frente ativa de intercessores que clamam pela igreja, pelos pastores, pelas famílias e pela cidade.",
      "Às quintas-feiras às 20h temos o Culto de Oração, aberto a todos os irmãos. Além disso, temos correntes de oração temáticas, vigílias e plantão de pedidos enviados pelos membros e visitantes através do site.",
    ],
    activities: [
      "Culto de Oração — Quintas às 20h",
      "Vigílias mensais",
      "Correntes de jejum e oração",
      "Plantão de intercessão pelos pedidos recebidos pelo site",
    ],
    leaders: [
      {
        name: "Paula",
        role: "Líder do Ministério de Oração",
        bio:
          "Serva dedicada à oração, clamando pelo mover de Deus em cada vida, família e situação da igreja.",
        image: null,
      },
    ],
    cta: "Tem um pedido? Envie pelo formulário e estaremos orando por você.",
  },
  {
    slug: "diaconos",
    title: "Diáconos",
    icon: "Shield",
    description:
      "Servindo com excelência, cuidando da casa de Deus e do povo de Deus.",
    hero: null,
    tagline: "Quem quiser ser grande, seja servo de todos.",
    history: [
      "O Ministério de Diáconos da PIBG segue o modelo bíblico de Atos 6 — homens e mulheres cheios do Espírito Santo, separados para servir a igreja em todas as áreas práticas, liberando os pastores e líderes para se dedicarem à Palavra e à oração.",
      "Nossos diáconos cuidam da recepção dos visitantes, da Santa Ceia, do espaço físico, da segurança, das ofertas e do bem-estar da congregação durante os cultos. São o rosto acolhedor da PIBG para quem chega pela primeira vez.",
    ],
    activities: [
      "Recepção e acolhimento de visitantes",
      "Organização da Santa Ceia",
      "Cuidado do espaço, ofertas e logística dos cultos",
      "Visitação aos enfermos e necessitados",
    ],
    leaders: [
      {
        name: "Katiuscia",
        role: "Diaconisa",
        bio:
          "Serva chamada para cuidar da ordem, servir as mesas e apoiar as famílias da igreja.",
        image: "/ministries/diaconos/diaconos-lider-1.png",
      },
    ],
    cta: "Quer fazer parte da equipe diaconal? Fale com a pastoral.",
  },
  {
    slug: "sisterhood",
    title: "SisterHood",
    icon: "Heart",
    description:
      "Mulheres na fé, irmãs no propósito — encontros de adoração, oração e cura para a mulher cristã.",
    hero: "/ministries/sisterhood/sisterhood-hero.jpg",
    tagline: "Onde irmãs se erguem juntas para serem tudo aquilo que Deus chamou.",
    theme: {
      bg: "#FDF8F8",
      accent: "#C9687A",
      accentLight: "#F9E8EC",
      text: "#3D1A24",
      muted: "#7A4A56",
    },
    bibleQuote: {
      text: "Força e dignidade são o seu traje; ela ri dos dias vindouros. Abre a boca com sabedoria, e a lei da benignidade está na sua língua.",
      ref: "Provérbios 31:25-26",
    },
    upcomingEvents: [
      { date: "7 de junho, 2026",    label: "Encontro SisterHood — junho"   },
      { date: "1 de agosto, 2026",   label: "Encontro SisterHood — agosto"  },
      { date: "3 de outubro, 2026",  label: "Encontro SisterHood — outubro" },
      { date: "5 de dezembro, 2026", label: "Encontro SisterHood — dezembro"},
    ],
    history: [
      "SisterHood é o ministério de mulheres da PIBG — um espaço seguro onde irmãs em Cristo se encontram para adorar, orar, confessar, ser curadas e crescer juntas. Cremos que a mulher cristã carrega um chamado único de Deus para sua família, sua igreja e sua geração.",
      "Em nossos encontros, abrimos espaço para a Palavra ministrada com profundidade, momentos de oração intensa, abraços que curam feridas e amizades que sustentam. Cada irmã é vista, ouvida e amada como Jesus a vê.",
    ],
    activities: [
      "Encontros mensais de SisterHood (1º sábado do mês par)",
      "Cultos especiais e mini-conferências femininas",
      "Roda de oração e cura interior",
      "Ações sociais e mentoria entre as irmãs",
    ],
    gallery: [
      {
        url: "/ministries/sisterhood/sisterhood-gallery-1.jpg",
        alt: "Irmãs adorando juntas no palco do SisterHood",
        caption: "Louvor que transforma — mulheres erguendo a voz para Deus",
      },
      {
        url: "/ministries/sisterhood/sisterhood-gallery-2.jpg",
        alt: "Três irmãs abraçadas no encontro do SisterHood",
        caption: "Laços que a fé constrói — amizades para a vida toda",
      },
      {
        url: "/ministries/sisterhood/sisterhood-gallery-4.jpg",
        alt: "Mesa decorada com flores e detalhes do evento SisterHood",
        caption: "Cada detalhe preparado com carinho para honrar cada irmã",
      },
    ],
    leaders: [
      {
        name: "Pastora Regina",
        role: "Líder do SisterHood",
        bio:
          "Mulher consagrada que pastoreia e abraça cada irmã da PIBG com amor e profundidade espiritual.",
        image: "/ministries/sisterhood/sisterhood-leader.jpg",
      },
    ],
    cta: "É mulher e quer fazer parte deste mover? Te esperamos no próximo encontro.",
  },
  {
    slug: "midia",
    title: "Mídia",
    icon: "Video",
    description:
      "Tecnologia e criatividade a serviço da mensagem — cuidando do áudio, projeção, transmissões e mídias sociais.",
    hero: null,
    tagline: "Nos bastidores, para que a Palavra alcance todos os cantos.",
    history: [
      "O Ministério de Mídia da PIBG trabalha nos bastidores para garantir que cada palavra, cada louvor e cada mensagem sejam transmitidas com clareza e excelência. Somos os responsáveis pelo som, pelas projeções, pelas transmissões ao vivo e pela presença digital da igreja.",
      "Nossa equipe é formada por técnicos de áudio, operadores de câmera, editores de vídeo, designers e gestores de mídias sociais — todos usando seus dons técnicos para expandir o alcance do Evangelho. Acreditamos que a tecnologia, quando usada com propósito, multiplica o impacto da igreja.",
    ],
    activities: [
      "Operação de som e microfones nos cultos",
      "Projeção de letras e versículos",
      "Transmissão ao vivo dos cultos",
      "Gestão de mídias sociais e edição de vídeos",
    ],
    leaders: [
      {
        name: "Equipe de Mídia PIBG",
        role: "Técnicos de AudioVisual",
        bio:
          "Profissionais e voluntários dedicados a fazer da tecnologia um instrumento de evangelização.",
        image: null,
      },
    ],
    cta: "Tem habilidades técnicas? Sua experiência em áudio, vídeo ou design pode servir ao Reino.",
  },
];

// ------- LIDERANÇA -------
export const LEADERSHIP = [
  {
    name: "Durvalino Mendonça",
    role: "Pastor Fundador",
    partner: "Pastora Regina Mendonça",
    image:
      "/leadership/Durvalino e Regina.jpg",
    bio: "Fundador da Primeira Igreja Brasileira de Greenville em 2019, o Pastor Durvalino carrega uma paixão ardente pelo Evangelho e pelo crescimento da igreja. Com anos de experiência ministerial, ele pastoreia com graça, sabedoria e um coração genuíno pelo povo de Deus. Ao lado de sua esposa Regina, formam uma equipe de fé que lidera com amor e dedicação.",
  },
  {
    name: "Honório Vieira",
    role: "Pastor",
    partner: "Hedila Vieira",
    image:
      "/leadership/Honorio e Hedila.jpg",
    bio: "Pastor Honório serve com fervor na PIBG, trazendo ensino profundo da Palavra e aconselhamento pastoral. Sua jornada de fé é marcada por compromisso com a comunidade e dedicação em discipular novos crentes. Junto com sua esposa Hedila, são exemplo de parceria ministerial e amor ao rebanho.",
  },
  {
    name: "Wellington Faria",
    role: "Presbítero",
    partner: "Katiuscia Faria",
    image:
      "/leadership/Wellington e Katiuscia.jpg",
    bio: "Presbítero Wellington serve na PIBG com dedicação, cuidando dos aspectos administrativos e ministeriais da igreja. Sua experiência em liderança e gestão tem sido fundamental para o crescimento organizacional da igreja. Ao lado de sua esposa Katiuscia, que serve como lider no ministério de diaconos, formam uma dupla comprometida em servir ao povo de Deus.",
  },
  {
    name: "Fernando Tomaz",
    role: "Presbítero",
    partner: "Sueli Tomaz",
    image:
      "/leadership/Fernando e Sueli.jpg",
    bio: "Presbítero Fernando traz sua experiência em adoração e ensino bíblico para a liderança da PIBG. Apaixonado pelo louvor e pela Palavra, ele auxilia na direção espiritual da igreja. Com sua esposa Sueli, que também serve no louvor, são um casal exemplo de serviço e devoção à casa de Deus.",
  },
];

// ------- DEPOIMENTOS / TESTEMUNHOS -------
export const TESTIMONIALS = [
  {
    name: "Wellington Diekes Faria",
    role: "Presbítero",
    quote:
      "Estou na PIBG desde o primeiro dia, em 2019. O que mais me alegra é ver minha família servindo junto. Katiuscia, minha esposa, lidera os diáconos e canta no louvor. Nosso filho Vinicius cuida do audiovisual e das lives. Nossa filha Ana Beatriz toca violão no ministério de louvor. Deus transformou nossa família em uma família que serve — e a PIBG é onde isso acontece.",
  },
  {
    name: "Katiuscia",
    role: "Líder dos Diáconos & Ministério de Louvor",
    quote:
      "Em 2019 meu marido Wellington me trouxe para a PIBG e desde então esta igreja se tornou nossa casa. Aqui servimos juntos, crescemos juntos e criamos nossos filhos Vinicius e Ana Beatriz no amor de Deus.",
  },
  {
    name: "Matheus",
    role: "Líder do Ministério de Jovens",
    quote:
      "Foi na PIBG que encontrei a Jesus. Aqui me batizei, aqui me casei com Vanessa, e aqui nasceram nossos dois filhos. Cada etapa da minha vida foi marcada pela graça de Deus nesta família.",
  },
  {
    name: "Vanessa",
    role: "Membro",
    quote:
      "Vi meu marido Matheus ser transformado pelo amor de Deus na PIBG. Aqui ele se batizou, aqui nos casamos, e aqui nasceram nossos filhos. Esta igreja é o alicerce da nossa família.",
  },
  {
    name: "Fernando Tomaz",
    role: "Líder do Ministério de Louvor",
    quote:
      "Desde o primeiro culto da PIBG, a minha família e eu temos a honra de liderar o louvor. Ver a congregação adorar a Deus é o que me motiva a continuar servindo com excelência.",
  },
  {
    name: "Nando",
    role: "Ministério de Louvor",
    quote:
      "Foi na PIBG que encontrei Bruna e construímos nossa família. Hoje toco baixo no ministério de louvor e vejo nossa filha crescer nos braços desta igreja que nos uniu.",
  },
  {
    name: "Bruna",
    role: "Membro",
    quote:
      "Comecei minha caminhada na PIBG e aqui Deus me presenteou com Nando, baixista do ministério de louvor. Hoje somos uma família abençoada com uma filha linda, nascida e criada nos braços desta igreja.",
  },
  {
    name: "Julia",
    role: "Membro",
    quote:
      "Foi com a bênção da PIBG que me casei com Renan. Juntos seguimos caminhando nessa jornada de fé, crescendo e servindo lado a lado nesta família que Deus nos deu.",
  },
  {
    name: "Renan",
    role: "Membro",
    quote:
      "A PIBG abençoou meu casamento com Julia. Juntos seguimos servindo e crescendo nesta família de fé que Deus nos deu.",
  },
];
